const classNames = (...classes: any[]) => {
  return classes.filter(Boolean).join(' ');
};

const timeSaved = (seconds: any) => {
  const hours = Math.floor(((seconds % 31536000) % 86400) / 3600);
  const minutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);

  let time = '';
  if (hours === 0 && minutes === 0) time = `about a minute`;
  if (hours === 0 && minutes > 0) time = `${minutes} minutes`;
  if (hours === 1 && minutes === 0) time = `an hour`;
  if (hours === 1 && minutes > 0) time = `an hour and ${minutes} minutes`;
  if (hours > 1 && minutes === 0) time = `${hours} hours`;
  if (hours > 1 && minutes > 0) time = `${hours} hours and ${minutes} minutes`;

  return time;
};

const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';
  if (phoneNumber?.startsWith('+1')) phoneNumber = phoneNumber.slice(2);
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }

  return phoneNumber;
};

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const formatDateTime = (dateTimeString: string | number | Date) => {
  if (!dateTimeString) return 'N/A';

  let date;
  if (typeof dateTimeString === 'string') {
    if (dateTimeString.includes('UTC')) {
      date = new Date(dateTimeString.replace(' ', 'T').replace(' UTC', 'Z'));
    } else {
      date = new Date(dateTimeString);
    }
  } else {
    date = new Date(dateTimeString);
  }

  // Handle any unexpected invalid date
  if (isNaN(date.getTime())) return 'N/A';

  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

const formatDateMMDDYYYY = (dateString: string | number | Date): string => {
  if (!dateString) return 'N/A';

  let date: Date;
  if (typeof dateString === 'string') {
    if (dateString.includes('UTC')) {
      date = new Date(dateString.replace(' ', 'T').replace(' UTC', 'Z'));
    } else {
      date = new Date(dateString);
    }
  } else {
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) return 'N/A';

  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

const usTimezones = [
  { value: 'America/New_York', label: 'Eastern Time (US & Canada)' },
  { value: 'America/Chicago', label: 'Central Time (US & Canada)' },
  { value: 'America/Denver', label: 'Mountain Time (US & Canada)' },
  { value: 'America/Phoenix', label: 'Arizona' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (US & Canada)' },
  { value: 'America/Anchorage', label: 'Alaska' },
  { value: 'Pacific/Honolulu', label: 'Hawaii' },
];

export { classNames, timeSaved, formatPhoneNumber, USDollar, formatDateTime, formatDateMMDDYYYY, usTimezones };
